import i18n from './view';

export default i18n;
